import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./Gallery.css";

import img1 from "../Images/gallery1.webp";
import img2 from "../Images/gallery2.webp";
import img3 from "../Images/gallery3.webp";
import img4 from "../Images/gallery4.webp";
import img5 from "../Images/gallery5.webp";
import img6 from "../Images/gallery6.webp";

const Gallery = () => {
  const images = [img1, img2, img3, img4, img5, img6];

  return (
    <section className="gallery-section" id="gallery">
      <div className="gallery-container">
        <h2 className="gallery-title">Divya Darshan Gallery</h2>
        <p className="gallery-text">
          Experience the spiritual journey and the devotion of our Garuda Sena Volunteers.
        </p>

        <Swiper
          modules={[Autoplay, Navigation, Pagination]}
          spaceBetween={30}
          slidesPerView={3}
          centeredSlides={true}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          className="gallery-swiper"
        >
          {images.map((img, index) => (
            <SwiperSlide key={index} className="gallery-slide">
              <div className="gallery-item">
                <img src={img} alt={`Gallery ${index + 1}`} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="gallery-cta">
          <a href="/gallery" className="cta-button">
            View Divine Moments
          </a>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
